export const LAYOUT_IMPORTACAO_OCORRENCIAS = {
  fileName: 'layout-importacao-ocorrencias-premiacao.xlsx',
  fileNameComRegistros: 'layout-importacao-ocorrencias-premiacao-com-registros.xlsx',
  columns: [
    { posicao: 1, nome: 'CPFMotorista', descricao: 'CPF do motorista (11 digitos)', obrigatorio: true },
    { posicao: 2, nome: 'Código Infração', descricao: 'Id da infracao cadastrada', obrigatorio: true },
    { posicao: 3, nome: 'Mês Fechamento', descricao: 'Mes de fechamento (1 a 12)', obrigatorio: true },
    { posicao: 4, nome: 'Ano Fechamento', descricao: 'Ano de fechamento', obrigatorio: true }
  ],
  observacoes: [
    'A importacao substitui todas as ocorrencias dos CPFs informados no arquivo.',
    'CPFs que nao estiverem no arquivo permanecem inalterados.',
    'Um mesmo CPF pode ter varias linhas no arquivo.'
  ]
};

export const LAYOUT_IMPORTACAO_INFRACOES = {
  fileName: 'layout-importacao-infracoes-premiacao.xlsx',
  fileNameComRegistros: 'layout-importacao-infracoes-premiacao-com-registros.xlsx',
  columns: [
    { posicao: 1, nome: 'Id', descricao: 'Id da infracao (opcional)', obrigatorio: false },
    { posicao: 2, nome: 'Descricao', descricao: 'Descricao da infracao', obrigatorio: true },
    { posicao: 3, nome: 'Descricao Grupo', descricao: 'Descricao do grupo', obrigatorio: false },
    { posicao: 4, nome: 'Descricao Plano Acao', descricao: 'Descricao do plano de acao', obrigatorio: false },
    { posicao: 5, nome: 'Porcentagem Desconto', descricao: 'Porcentagem de desconto', obrigatorio: true }
  ],
  observacoes: [
    'Upsert por Id quando informado, ou por Descricao quando o Id estiver vazio.',
    'Valores decimais podem usar virgula ou ponto.'
  ]
};

export const LAYOUT_IMPORTACAO_TABELAS = {
  fileName: 'layout-importacao-tabelas-premiacao.xlsx',
  fileNameComRegistros: 'layout-importacao-tabelas-premiacao-com-registros.xlsx',
  columns: [
    { posicao: 1, nome: 'Nome', descricao: 'Nome da tabela (chave de upsert)', obrigatorio: true },
    { posicao: 2, nome: 'Segment', descricao: 'Segmento da tabela', obrigatorio: true },
    { posicao: 3, nome: 'Fat. Inicio', descricao: 'Faixa inicial de faturamento', obrigatorio: true },
    { posicao: 4, nome: 'Fat. Final', descricao: 'Faixa final de faturamento', obrigatorio: true },
    { posicao: 5, nome: 'Media Ideal', descricao: 'Media ideal', obrigatorio: true },
    { posicao: 6, nome: 'Media Excelente', descricao: 'Media excelente', obrigatorio: true },
    { posicao: 7, nome: 'Valor Premiacao', descricao: 'Valor da premiacao', obrigatorio: true },
    { posicao: 8, nome: 'Valor Premiacao Excelente', descricao: 'Valor da premiacao excelente', obrigatorio: true },
    { posicao: 9, nome: 'Porcentagem Desconto (Média)', descricao: 'Porcentagem de desconto por media', obrigatorio: true }
  ],
  observacoes: [
    'A importacao cria ou atualiza tabelas com base na coluna Nome.',
    'Valores decimais podem usar virgula ou ponto.'
  ]
};

export const LAYOUT_IMPORTACAO_RELACIONAMENTOS = {
  fileName: 'layout-importacao-relacionamentos-frota-tabela.xlsx',
  fileNameComRegistros: 'layout-importacao-relacionamentos-frota-tabela-com-registros.xlsx',
  columns: [
    { posicao: 1, nome: 'Id Tabela', descricao: 'Id da tabela de premiacao (opcional se informar nome)', obrigatorio: false },
    { posicao: 2, nome: 'Nome Tabela Premiação', descricao: 'Nome da tabela (usado se Id Tabela estiver vazio)', obrigatorio: false },
    { posicao: 3, nome: 'Número Frota', descricao: 'Numero da frota', obrigatorio: true }
  ],
  observacoes: [
    'Informe Id Tabela ou Nome Tabela Premiação.',
    'A importacao atualiza somente as frotas presentes no arquivo.',
    'Se a frota ja possuir vinculo ativo, o relacionamento sera atualizado.'
  ]
};
